import { Acquirers } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState,
    startCreateReducer, createReducer, getReducer, listReducer,
    updateReducer, deleteReducer,
    startCreateAction, createAction, getAction, listAction,
    updateAction, deleteAction
} = createRestSlices(Acquirers);

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        startCreateReducer, createReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
    ]);
}

/* Export CRUD actions */
export const startCreateAcquirer = startCreateAction;
export const createAcquirer      = createAction;
export const loadAcquirer        = getAction;
export const loadAcquirers       = listAction;
export const updateAcquirer      = updateAction;
export const deleteAcquirer      = deleteAction;
